import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "49.927",
  width: "50",
  viewBox: "0 0 50 49.927",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.8",
    d: "M17.152 16.278c2.513-.255 5.135-.4 7.83-.4 2.694 0 5.353.145 7.83.4C31.718 7.283 28.95.765 25.636 0H24.4c-3.35.765-6.12 7.283-7.248 16.278z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.315 32.775c-.255-2.513-.4-5.135-.4-7.83 0-2.694.145-5.353.4-7.83C6.81 18.282.035 21.34 0 24.91v.035c.036 3.605 6.81 6.664 16.315 7.83z"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.8",
    d: "M32.92 17.007c-2.475-.29-5.134-.437-7.938-.437-2.768 0-5.426.146-7.94.437-.29 2.476-.436 5.135-.436 7.94s.146 5.425.437 7.938c2.477.29 5.135.437 7.94.437 2.767 0 5.425-.146 7.938-.437.3-2.477.44-5.135.44-7.94s-.14-5.425-.43-7.938z"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.8",
    d: "M32.848 33.613c-2.513.255-5.135.4-7.83.4-2.694 0-5.353-.145-7.866-.4 1.166 9.54 4.225 16.315 7.83 16.315 3.605 0 6.664-6.774 7.866-16.315z"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.6",
    d: "M31.61 7.028c.91 2.695 1.566 5.864 2.003 9.323 3.46.41 6.628 1.1 9.323 2.01 3.423 1.13 5.79 2.59 6.955 4.19C48.73 10.71 39.33 1.28 27.5.11c1.566 1.2 2.986 3.568 4.115 6.918z"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.6",
    d: "M50 24.945v-.036c-.036-3.57-6.81-6.63-16.315-7.8.255 2.51.4 5.13.4 7.83 0 2.69-.145 5.312-.436 7.83 9.54-1.17 16.31-4.23 16.35-7.83z"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.6",
    d: "M42.9 31.537c-2.696.91-5.864 1.566-9.324 2.003-.4 3.46-1.092 6.628-2.003 9.322-1.165 3.496-2.658 5.9-4.297 7.03 11.98-1.094 21.486-10.598 22.578-22.58-1.13 1.64-3.532 3.06-6.955 4.225z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.39 42.862c-.91-2.695-1.566-5.863-2.003-9.323-3.46-.4-6.628-1.1-9.323-2.01-3.386-1.16-5.79-2.58-6.954-4.22C1.2 39.254 10.742 48.795 22.686 49.89c-1.64-1.165-3.132-3.57-4.297-7.028z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.1 18.354c2.696-.91 5.864-1.566 9.324-2.003.4-3.46 1.092-6.62 2.003-9.32 1.13-3.35 2.55-5.71 4.115-6.92C10.67 1.28 1.275 10.71.11 22.55c1.2-1.602 3.568-3.06 6.99-4.188z"
  })]
});